<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Assegnazioni</h1>
                <p>Ci sono {{ get(false).length }} assegnazioni registrate nel sistema</p>
                <button type="button" class="btn btn-primary" (click)="handleModal(undefined, 'create')">Aggiungi</button>
            </div>
        </div>
    </div>

    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand">Visualizza</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar_assegnazioni" aria-controls="navbar_assegnazioni" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse flex-row justify-content-between" id="navbar_assegnazioni">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link btn" 
                    [ngClass]="{'active': queryparams()['assegnazione-presenze-view'] == 'riepilogo' || !queryparams()['assegnazione-presenze-view']}"
                    [routerLink]="'/assegnazioni'" 
                    [queryParams]="changeQueryParam({'assegnazione-presenze-view': 'riepilogo'})">Riepilogo</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link btn" 
                    [ngClass]="{'active': queryparams()['assegnazione-presenze-view'] == 'calendario'}"
                    [routerLink]="'/assegnazioni'" 
                    [queryParams]="changeQueryParam({'assegnazione-presenze-view': 'calendario'})">Calendario</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link btn" 
                    [ngClass]="{'active': queryparams()['assegnazione-presenze-view'] == 'archivio'}"
                    [routerLink]="'/assegnazioni'" 
                    [queryParams]="changeQueryParam({'assegnazione-presenze-view': 'archivio'})">Archivio</a>
                </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
                <input class="form-control mr-sm-2" type="search" placeholder="Inserisci filtro di ricerca" aria-label="Search" [(ngModel)]="filter.text" name="filter_text">
            </form>
        </div>
    </nav>

    <div class="row mt-5" [hidden]="queryparams()['assegnazione-presenze-view'] != 'riepilogo' && queryparams()['assegnazione-presenze-view'] != 'archivio'">
        <div class="col">
            <div [hidden]="!get(false).length" class="table-responsive-md">
                <table class="table">
                    <thead class="thead-primary">
                        <tr>
                            <th scope="col">Cliente</th>
                            <th scope="col">Sede</th>
                            <th scope="col">Dipendente</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-row cursor-pointer" *ngFor="let assegnazione of get(false); index as i" (click)="handleModal(assegnazione.public_token, 'update')">
                            <td scope="col">{{ assegnazione.configuration.cliente.nome }}</td>
                            <td scope="col">{{ assegnazione.configuration.sede }}</td>
                            <td scope="col">{{ assegnazione.configuration.dipendente.nome }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="mt-5" [hidden]="queryparams()['assegnazione-presenze-view'] != 'calendario'">
        <div class="row mb-5">
            <div class="col">
                <div class="calendar">
                    <header>
                        <h2>{{ getMonth() }}</h2>
                        <a class="btn-prev fontawesome-angle-left" 
                        [routerLink]="'/assegnazioni'" 
                        [queryParams]="changeQueryParam({'assegnazione-calendar': getCurrent().add(-1, 'month').valueOf() })">&#8592;</a>

                        <a class="btn-next fontawesome-angle-right" 
                        [routerLink]="'/assegnazioni'" 
                        [queryParams]="changeQueryParam({'assegnazione-calendar': getCurrent().add(1, 'month').valueOf() })">&#8594;</a>
                    </header>
                    <table class="calendar-table">
                        <thead>
                            <tr>
                                <td>Lun</td>
                                <td>Mar</td>
                                <td>Mer</td>
                                <td>Gio</td>
                                <td>Ven</td>
                                <td>Sab</td>
                                <td>Dom</td>
                            </tr>
                        </thead>

                        <tbody>

                            <tr *ngFor="let week of getCurrentMonth(); index as i">
                                <td *ngFor="let day of week; index as i"
                                (click)="!!day.number && setCurrentDay(day.day)" 
                                [ngClass]="getCellClass(day)">
                                    {{ day.number || '' }}
                                </td>
                            </tr>

                        </tbody>

                    </table>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div [hidden]="!getCurrentAssegnazioni().length" class="table-responsive-md">
                    <table class="table">
                        <thead class="thead-primary">
                            <tr>
                                <th scope="col">Cliente</th>
                                <th scope="col">Sede</th>
                                <th scope="col">Dipendente</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-row cursor-pointer" *ngFor="let assegnazione of getCurrentAssegnazioni(); index as i" (click)="handleModal(assegnazione.public_token_assegnazione, 'update')">
                                <td scope="col">{{ getSingleAssegnazione(assegnazione.public_token_assegnazione).configuration.cliente.nome }}</td>
                                <td scope="col">{{ getSingleAssegnazione(assegnazione.public_token_assegnazione).configuration.sede }}</td>
                                <td scope="col">{{ getSingleAssegnazione(assegnazione.public_token_assegnazione).configuration.dipendente.nome }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<span id="assegnazioneModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" style="overflow-y: scroll;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title">{{ queryparams()['type'] == 'create' ? "Aggiungi assegnazione" : "Assegnazione" }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(undefined, undefined)">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col">
                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" id="iseveryone" name="iseveryone" (change)="updateModel($event, 'everyone')" [(ngModel)]="getAssegnazione().configuration.everyone">
                                <label class="form-check-label" for="iseveryone">L&apos;assegnazione coinvolger&agrave; tutti i dipendenti</label>
                            </div>
                        </div>
                    </div>

                    <form>
                        <!-- SELEZIONE DIPENDENTE/I -->
                        <div class="form-group">
                            <select class="custom-select" [(ngModel)]="temp.dipendente" name="dipendente" (change)="updateModel($event)">
                                <option value="">Seleziona un dipendente</option>
                                <option [ngValue]="dipendente.public_token" [selected]="getAssegnazione().configuration.dipendente.public_token == dipendente.public_token" *ngFor="let dipendente of getDipendenti(false); index as i">{{ dipendente.public_configuration.nome }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <select class="custom-select" (change)="updateModel($event, 'group')">
                                <option value="">Scegli un gruppo di dipendenti</option>
                                <option [value]="group.id" [selected]="getAssegnazione().configuration.group == group.id" *ngFor="let group of window.usher.get()?.public_configuration?.groups; index as i">{{ group.name }}</option>
                            </select>
                        </div>

                        <!-- SELEZIONE CLIENTE -->
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <select class="custom-select" [(ngModel)]="temp.cliente" name="cliente" (change)="updateModel($event)">
                                    <option value="">Seleziona un cliente</option>
                                    <option [ngValue]="cliente.public_token" [selected]="getAssegnazione().configuration.cliente.public_token == cliente.public_token" *ngFor="let cliente of getClienti(false); index as i">{{ cliente.public_configuration.nome }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6" *ngIf="!!temp.cliente">
                                <select class="custom-select" [(ngModel)]="temp.indirizzo" name="indirizzo_cliente" (change)="updateModel($event)">
                                    <option value="">Seleziona l'indirizzo del cliente</option>
                                    <option [ngValue]="indirizzo.id" *ngFor="let indirizzo of getIndirizzi(); index as i">{{ indirizzo.formatted_address }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6" [hidden]="!!temp.cliente">
                                <input type="text" class="form-control col-12" id="indirizzo_assegnazione_autocomplete" placeholder="Indirizzo">
                            </div>
                        </div>
                    </form>

                    <div class="row">
                        <div class="col">
                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" id="geolocation_requested" name="geolocation_requested" [(ngModel)]="getAssegnazione().configuration.geolocation_requested">
                                <label class="form-check-label" for="geolocation_requested">Necessita della geolocalizzazione</label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" id="show_calendar" name="show_calendar" [(ngModel)]="getAssegnazione().configuration.show_calendar">
                                <label class="form-check-label" for="show_calendar">Mostra nel calendario</label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <h5 class="text-center mb-4 mt-4"><button class="btn btn-light" (click)="newCalendarItem()">Aggiungi occorrenza +</button></h5>
                        </div>
                    </div>
                    
                    <div class="card text-center mb-2" *ngFor="let calendar_obj of getAssegnazione().configuration.calendar; index as i">
                        <div class="card-header">{{i+1}}&deg; Assegnazione<span class="btn btn-sm pt-0 pb-0 float-right" (click)="getAssegnazione().configuration.calendar.splice(i, 1)"><i class="fa fa-times"></i></span></div>
                        <div class="card-body">
                            <form>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <select class="custom-select" [(ngModel)]="calendar_obj.frequenza" (change)="formatoGiorno(i)" name="frequenza">
                                            <option value="settimanale">Cadenza settimanale</option>
                                            <option value="quindicinale">Cadenza quindicinale</option>
                                            <option value="mensile">Cadenza mensile</option>
                                            <option value="una-tantum">Evento straordinario</option>
                                        </select>
                                    </div>
                                    <div class="col-md-6" [hidden]="calendar_obj.frequenza != 'una-tantum'">
                                        <span class="form-control cursor-pointer background-hover" (click)="datepickers[calendar_obj.id]?.data.show()">{{ window.flowup.utils.getDate(calendar_obj.data_inizio)}}</span>
                                    </div>
                                    <div class="form-group col-md-6" [hidden]="calendar_obj.frequenza == 'una-tantum'">
                                        <select class="custom-select" [(ngModel)]="calendar_obj.giorno" name="una_tantum">
                                            <option value="1">Lunedì</option>
                                            <option value="2">Martedì</option>
                                            <option value="3">Mercoledì</option>
                                            <option value="4">Giovedì</option>
                                            <option value="5">Venerdì</option>
                                            <option value="6">Sabato</option>
                                            <option value="7">Domenica</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-12" [hidden]="calendar_obj.frequenza != 'quindicinale'">
                                        <select class="custom-select" [(ngModel)]="calendar_obj.settimana" name="frequenza_settimane">
                                            <option value="0">Settimane pari</option>
                                            <option value="1">Settimane dispari</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-12" [hidden]="calendar_obj.frequenza != 'mensile'">
                                        <select class="custom-select" [(ngModel)]="calendar_obj.settimana" name="numero_settimana">
                                            <option value="1">Prima settimana</option>
                                            <option value="2">Seconda settimana</option>
                                            <option value="3">Terza settimana</option>
                                            <option value="4">Quarta settimana</option>
                                        </select>
                                    </div>

                                    <div class="col-md-12 mb-2" [hidden]="calendar_obj.frequenza == 'una-tantum'">
                                        <label>Data di inizio</label>
                                        <span class="form-control cursor-pointer background-hover" (click)="datepickers[calendar_obj.id]?.data.show()">{{ window.flowup.utils.getDate(calendar_obj.data_inizio)}}</span>
                                    </div>

                                    <div class="col-md-6 mb-2">
                                        <label>Ora di inizio</label>
                                        <span class="form-control cursor-pointer background-hover" (click)="datepickers[calendar_obj.id]?.ora_inizio.show()">{{ window.flowup.utils.getTimeFromMinutes(calendar_obj.ora_inizio) }}</span>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label>Ora di fine</label>
                                        <span class="form-control cursor-pointer background-hover" (click)="datepickers[calendar_obj.id]?.ora_fine.show()">{{ window.flowup.utils.getTimeFromMinutes(calendar_obj.ora_fine) }}</span>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" [hidden]="!!getAssegnazione().configuration.archived" (click)="handleAssegnazione()">{{ queryparams()['type'] == 'create' ? 'Aggiungi' : 'Aggiorna' }}</button>
                    <button type="button" class="btn btn-primary" [hidden]="!getAssegnazione().configuration.archived" (click)="recoverAssegnazione()">Ripristina</button>
                    <button type="button" class="btn btn-danger" [hidden]="!getAssegnazione().public_token || queryparams()['type'] != 'update' || !!getAssegnazione().configuration.archived" (click)="handleModal(getAssegnazione().public_token, 'delete')">Archivia</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(undefined, undefined)">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>

<span id="deleteAssegnazioneModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Conferma</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(getAssegnazione().public_token, 'update')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <p>Sei sicuro di voler archiviare questa assegnazione?</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" [hidden]="!getAssegnazione().public_token || queryparams()['type'] != 'delete' || !!getAssegnazione().configuration.archived" (click)="deleteAssegnazione()">Archivia</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(getAssegnazione().public_token, 'update')">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>